<template>
  <div>
    <div class="header">
      <span class="font-weight-bold">1분만에 가입</span>하고, <br /><span>20% 할인 혜택 받아가세요</span>
    </div>

    <v-row>
      <v-col cols="12" class="mt-6 mb-2">
        <v-col v-if="!userIsAuthenticated">
          <v-col>
            <v-col class="mb-1">
              <div class="label">이메일 주소*</div>
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.email"
                class="font-13"
                name="email"
                type="email"
                size="small"
                v-validate="'required|email|duplicatedEmail|adminEmail'"
                placeholder="업무용 이메일을 입력해주세요"
                :rules="[errors.first('email') || !errors.has('email')]"
                single-line
                outlined
                solo
                flat
                required></v-text-field>
            </v-col>
          </v-col>
        </v-col>
        <v-col v-if="!userIsAuthenticated">
          <v-col>
            <v-col class="mb-1">
              <div class="label">비밀번호*</div>
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.password"
                class="font-13"
                name="password"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                ref="password"
                placeholder="영어 대소문자 + 숫자로  8자 이상 입력해주세요"
                v-validate="'required|min:8'"
                :rules="[errors.first('password') || !errors.has('password')]"
                @click:append="showPassword = !showPassword"
                single-line
                outlined
                solo
                flat
                required
                append-outer-tab-index="-1">
              </v-text-field>
            </v-col>
          </v-col>
        </v-col>
        <v-col v-if="!userIsAuthenticated">
          <v-col>
            <v-col>
              <div class="label">비밀번호 확인*</div>
            </v-col>
            <v-col class="mt-1">
              <v-text-field
                v-model="form.password_confirmed"
                class="font-13"
                name="password_confirmed"
                :type="showPasswordConfirmed ? 'text' : 'password'"
                :append-icon="showPasswordConfirmed ? 'visibility' : 'visibility_off'"
                ref="password_confirmed"
                placeholder="영어 대소문자 + 숫자로  8자 이상 입력해주세요"
                v-validate="'required|min:8|confirmed:password'"
                :rules="[errors.first('password_confirmed') || !errors.has('password_confirmed')]"
                @click:append="showPasswordConfirmed = !showPasswordConfirmed"
                single-line
                outlined
                solo
                flat
                required>
              </v-text-field>
            </v-col>
          </v-col>
        </v-col>
      </v-col>
    </v-row>
    <v-btn :style="{ opacity: isSubmitDisabled ? '0.2' : '1' }" class="submit mb-4" text outlined @click="handleClick()"
      >다음</v-btn
    >
    <div class="login-text">이미 계정이 있으신가요? <router-link class="login" to="/signin">로그인</router-link></div>
  </div>
</template>

<script>
import userMixin from '@/components/shared/userMixin';

export default {
  name: 'UserInfo',
  mixins: [userMixin],
  data() {
    return {
      showPassword: false,
      showPasswordConfirmed: false,
    };
  },

  computed: {
    isSubmitDisabled() {
      const isRequiredFieldsFilled = this.form.email && this.form.password && this.form.password_confirmed;
      const hasNoErrors = this.$validator.errors.items.length === 0;

      return !isRequiredFieldsFilled || !hasNoErrors;
    },
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    nextStep: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    'form.password': function () {
      if (this.form.password) {
        this.$nextTick(() => {
          this.$validator.validate('password_confirmed');
        });
      }
    },
  },
  methods: {
    async handleClick() {
      if (this.isSubmitDisabled) {
        return;
      }

      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        return;
      }

      this.nextStep();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$validator.validateAll();
    });
  },
};
</script>

<style scoped lang="scss">
@import '../../../assets/scss/form.scss';
@import '../../../assets/scss/typo.scss';

.header {
  color: #000;
  font-family: 'Pretendard';
  font-size: 24px;
  font-style: normal;
  line-height: normal;
}

.label {
  color: var(--default-color);
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
}
.text-field {
  font-size: 13px;
}

.login-text {
  text-align: center;
  color: #9b9b9b;
}

.login {
  color: var(--primary_light, #ea2a3a);
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
}
</style>
